import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";
import MiseLogo from "./MiseLogo";
import SocialLinks from "./SocialLinks";
import { MARKETING_EMAIL } from "../../content/social";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-[#242424] bg-[#0d0d0d] mt-24" data-testid="site-footer">
      {/* Brand column, three link columns and the marketing contact: every column centred, headers on one line */}
      <div className="mise-container py-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-12 text-center">
        <div className="sm:col-span-2 lg:col-span-3 flex flex-col items-center">
          <MiseLogo className="h-10 w-auto" />
          <p className="mt-4 text-white/70 leading-relaxed">
            {t.footer.taglineLead.trim()}
            <span className="block mise-serif mise-accent text-lg leading-snug">{t.footer.taglineItalicA}</span>
            <span className="block mise-serif mise-accent text-lg leading-snug">
              {t.footer.taglineItalicB}
              <span className="text-white/70">.</span>
            </span>
          </p>
          <p className="mt-3 text-white/40 text-sm">{t.footer.builtIn}</p>
        </div>

        <div className="lg:col-span-2">
          <p className="mise-eyebrow mb-4">{t.footer.sections.platforms}</p>
          <ul className="space-y-2 text-white/70 text-sm">
            <li><Link to="/at-home" className="hover:text-white" data-testid="footer-at-home" data-track="footer-at-home">Mise at Home</Link></li>
            <li><Link to="/family-meals" className="hover:text-white" data-testid="footer-family-meals" data-track="footer-family-meals">Mise: Family Meals</Link></li>
            <li><Link to="/heart-of-house" className="hover:text-white" data-testid="footer-heart-of-house" data-track="footer-heart-of-house">Mise: Heart of House</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <p className="mise-eyebrow mb-4">{t.footer.sections.company}</p>
          <ul className="space-y-2 text-white/70 text-sm">
            <li><Link to="/about" className="hover:text-white" data-testid="footer-about" data-track="footer-about">{t.nav.about}</Link></li>
            <li><Link to="/media" className="hover:text-white" data-testid="footer-media" data-track="footer-media">{t.nav.media}</Link></li>
            <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact" data-track="footer-contact">{t.nav.contact}</Link></li>
            <li>
              <a
                href="https://misekitchen.ca"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white"
                data-testid="footer-misekitchen"
              >
                {t.footer.domain}
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <p className="mise-eyebrow mb-4">{t.footer.sections.follow}</p>
          <SocialLinks className="space-y-2 text-white/70 text-sm" testIdPrefix="footer-social" />
        </div>

        <div className="lg:col-span-3">
          <p className="mise-eyebrow mb-4">{t.footer.marketingLabel}</p>
          <a
            href={`mailto:${MARKETING_EMAIL}`}
            className="inline-block whitespace-nowrap text-white/70 text-sm hover:text-white"
            data-testid="footer-marketing-email"
            data-track="footer-marketing-email"
          >
            {MARKETING_EMAIL}
          </a>
        </div>
      </div>

      <div className="border-t border-[#242424]">
        <div className="mise-container py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/40">
          <span data-testid="footer-copyright">{t.footer.copyright}</span>
          <nav className="flex items-center gap-4" aria-label={t.footer.legal.label}>
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">{t.footer.legal.privacy}</Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-terms">{t.footer.legal.terms}</Link>
          </nav>
          <span>
            {t.footer.brand} · {t.footer.domain} · {t.footer.founder}
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
